import { CreateScenarioPage } from '@/app/pages/profile/create-scenario-page';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const createScenarioSearchSchema = z.object({
  scenarioId: z.string().optional(),
});

export const Route = createFileRoute('/profile/create-scenario')({
  validateSearch: createScenarioSearchSchema,
  component: CreateScenarioPage,
});
